export interface ISideboard {
  Header?: ISideboarHeader
  Footer?: ISideboardFooter
  minimizedAction?: ISideboardMinimizedAction
  isMinimized?: boolean
  isMaximized?: boolean
  VisibleMini: boolean
  VisibleClose: boolean
  VisibleMaximize?: boolean
}

export interface ISideboardMinimizedAction {
  label?: string
  ariaLabel: string
  icon: string
  tabTitle?: string
  execute: () => void
}

export interface ISideboarHeader {
  Visible?: boolean
  Title?: string
  VisibleTitle?: boolean
  // Icon?: string;
  Maximized?: boolean
}

export interface ISideboardFooter {
  Visible?: boolean
  ShowOk?: boolean
  ShowOkAll?: boolean
  ShowCancel?: boolean
  ShowDelete?: boolean
}

export enum Sideboardctions {
  Close = 'Close',
  Minimize = 'Minimize',
  Maximize = 'Maximize',
  Ok = 'Ok',
  OkAll = 'OkAll',
  Cancel = 'Cancel',
  MaximizedMobile = 'MaximizedMobile',
  MinimizedMobile = 'MinimizedMobile',
}

export interface ISideboardActions {
  Action: Sideboardctions
  Event?: any
  [Key: string]: any
}
